import { resolveFileUrl } from '@/utils/fileUrl';

interface AvatarProps {
  src?: string | null;
  name: string;
  size?: number;
}

function initials(name: string): string {
  return name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? '')
    .join('');
}

export function Avatar({ src, name, size = 40 }: AvatarProps) {
  const dimension = { width: size, height: size, fontSize: Math.round(size * 0.4) };
  const resolvedSrc = resolveFileUrl(src);

  if (resolvedSrc) {
    return (
      <img
        src={resolvedSrc}
        alt={name}
        style={dimension}
        className="rounded-full object-cover ring-1 ring-black/5"
      />
    );
  }

  return (
    <div
      style={dimension}
      className="flex items-center justify-center rounded-full bg-brand-100 font-semibold text-brand-700 dark:bg-brand-900 dark:text-brand-300"
      aria-hidden="true"
    >
      {initials(name) || '?'}
    </div>
  );
}
